import log from '$$log';
import Timeline from './timeline';
import Zoom from './zoom';
import Overdue from './overdue';
import Deadline from './deadline';
import CutArea from './cutArea';
import Filter from './filter';
import TodayMarker from './todayMarker';
import HighlightArea from './highlightArea';
import Dates from './dates';

export default {
  init(instance) {
    const tTimeline = log.time('ganttConfigure.chart.timeline');
    Timeline.init(instance);
    tTimeline.end();

    const tZoom = log.time('ganttConfigure.chart.zoom');
    Zoom.init(instance);
    tZoom.end();

    TodayMarker.init(instance);

    if (instance.config.isWorkload) {
      return;
    }

    Overdue.init(instance);
    Deadline.init(instance);
    CutArea.init(instance);
    HighlightArea.init(instance);
    Dates.init(instance);
    Filter.init(instance);
  },
};
